import { keyframes } from '@emotion/react';
import React from 'react';

import { Div } from '@kizi/core-components';

const spinKeyframe = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

export const Spinner = ({ ...rest }) => {
  const { width, height, color } = rest;
  return (
    <Div
      css={{
        display: 'inline-flex',
        animation: `${spinKeyframe} 0.8s linear 0s infinite normal`,
      }}
      {...rest}
    >
      <svg
        viewBox="0 0 16 16"
        height={height ? height : '1em'}
        width={width ? width : '1em'}
        aria-hidden="true"
        focusable="false"
        fill={color || 'currentColor'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 16c-2.137 0-4.146-.832-5.657-2.343S0 10.137 0 8c0-1.513.425-2.986 1.228-4.261A8.02 8.02 0 014.421.844l.672 1.341a6.53 6.53 0 00-2.596 2.354A6.48 6.48 0 001.5 8c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-.345-2.426-.997-3.461a6.515 6.515 0 00-2.596-2.354l.672-1.341a8.02 8.02 0 013.193 2.895A7.981 7.981 0 0116 8c0 2.137-.832 4.146-2.343 5.657S10.137 16 8 16z" />
      </svg>
    </Div>
  );
};
